module.exports = __webpack_public_path__ + "img/video.c7ec46c7.svg";